import { create } from 'zustand'

type NavigationStore = {
  isOpen: boolean
  setOpen: () => void
  setOpenValue: (value: boolean) => void
}

export const useNavigationStore = create<NavigationStore>((set) => ({
  isOpen: false,
  setOpen: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpenValue: (value) => set((state) => ({ isOpen: value }))
}))
